import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface ImpersonationState {
  impersonateMailboxId: string | null
  impersonateMailboxName: string | null
  setImpersonateMailbox: (id: string | null, name: string | null) => void
  clear: () => void
}

export const useImpersonation = create<ImpersonationState>()(
  persist(
    (set) => ({
      impersonateMailboxId: null,
      impersonateMailboxName: null,
      setImpersonateMailbox: (id, name) => set({ impersonateMailboxId: id, impersonateMailboxName: name }),
      clear: () => set({ impersonateMailboxId: null, impersonateMailboxName: null }),
    }),
    { name: 'torre-impersonation', version: 2 }
  )
)
